import { Link } from '@mui/material';
import Container from '@mui/material/Container';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import { FC, SyntheticEvent } from 'react';
import { Helmet } from 'react-helmet-async';
import { HiRefresh } from 'react-icons/hi';
import { HiCreditCard, HiShoppingBag } from 'react-icons/hi2';
import { CONFIG } from 'src/config-global';

import { PageContainer } from '#/components/page-container';
import { useClassicAreaLink } from '#/layouts/sidebar/use-classic-area-link';
import { useBillingPageNavigate, useBillingPageSearch } from '#/routes/_protected/billing';

import { OrdersTab } from './tabs/orders/orders-tab';
import { PaymentPlansTab } from './tabs/payment-plans/payment-plans-tab';
import { SubscriptionTab } from './tabs/subscription/subscription-tab';

// ----------------------------------------------------------------------

const TAB_KEYS = ['orders', 'subscription', 'payment-plans'] as const;

export const BillingPage: FC = () => {
  const { tab } = useBillingPageSearch();
  const navigate = useBillingPageNavigate();

  const activeTab = Math.max(
    0,
    TAB_KEYS.findIndex(item => (tab ? item === tab : item === 'orders')),
  );

  const handleTabChange = (_: SyntheticEvent, value: number) => {
    navigate({ search: { tab: TAB_KEYS[value] }, replace: true });
  };

  const { handleClassicPanelClick } = useClassicAreaLink();

  return (
    <>
      <Helmet>
        <title>{`Billing - ${CONFIG.appName}`}</title>
      </Helmet>
      <PageContainer>
        <Container maxWidth="xl" sx={{ p: 0 }}>
          <Typography variant="h4" fontWeight={700} sx={{ mb: { xs: 1, sm: 2 } }}>
            Billing Details
          </Typography>

          <Typography variant="body2" sx={{ mb: { xs: 1, sm: 2 } }}>
            Please visit the{' '}
            <Link href="#" onClick={() => handleClassicPanelClick('https://members.laurenohayon.com/payment-methods')}>
              Payment Method
            </Link>{' '}
            page to update your payment information
          </Typography>

          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }}
          >
            <Tab label="Orders" icon={<HiShoppingBag size={20} />} iconPosition="start" />
            <Tab label="Subscription" icon={<HiRefresh size={20} />} iconPosition="start" />
            <Tab label="Payment Plans" icon={<HiCreditCard size={20} />} iconPosition="start" />
          </Tabs>

          {activeTab === 0 && <OrdersTab />}
          {activeTab === 1 && <SubscriptionTab />}
          {activeTab === 2 && <PaymentPlansTab />}
        </Container>
      </PageContainer>
    </>
  );
};
